/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';

import HexGroup from 'solis/type/hex/group';

import ColonyZone from 'solis/react/board/data/colony.zone';

import ColonyValueBands from 'solis/claude/logic/colony/value.bands';


export default class extends Logic
{
  constructor ({ colony })
  {
    super(colony);

    this.valueBands = null;
  }


  getCenterDisplayHex ()
  {
    return new HexGroup(this.object.getZones().keys()).getCenter();
  }


  getZone (displayHex)
  {
    const zone = this.object.getZone(displayHex);

    return zone !== null ? new ColonyZone(zone, this) : null;
  }


  getZones ()
  {
    return this.object.getZones().values().map(zone => new ColonyZone(zone, this));
  }


  getSelectableZone (displayHex)
  {
    return this.getZone(displayHex);
  }


  toEntityHex (displayHex)
  {
    return displayHex;
  }


  toDisplayHex (entityHex)
  {
    return entityHex;
  }


  getValueBand (value)
  {
    return this.getValueBands().getBand(value);
  }


  getValueBands ()
  {
    if (this.valueBands === null)
    {
      this.valueBands = new ColonyValueBands(this.object);
    }

    return this.valueBands;
  }


};
